import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import { Dropdown } from "react-bootstrap";
import Routes from "./Routes";

function RouteGenerator({ excludeIds = [] }) {
  const [openId, setOpenId] = useState(null);
  const routes = Routes.filter((route) => !excludeIds.includes(route.id));

  return (
    <>
      {routes.map((route) => {
        return route.children ? (
          <Dropdown
            className="top-menue"
            key={route.id}
            show={openId === route.id}
            onMouseEnter={() => setOpenId(route.id)}
            onMouseLeave={() => setOpenId(null)}
            onToggle={(nextShow) => setOpenId(nextShow ? route.id : null)}
          >
            <Dropdown.Toggle
              variant="outline-secondary"
              className="top-menue-title"
            >
              {route.header}
            </Dropdown.Toggle>

            <Dropdown.Menu className="DropdownMenu">
              {route.children.map(({ id, link, header }) => (
                <Nav key={id}>
                  <a href={link} className="nav-link">
                    {header}
                  </a>
                </Nav>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <Nav key={route.link} id={route.id}>
            <a href={route.link} className="nav-link">
              {route.header}
            </a>
          </Nav>
        );
      })}
    </>
  );
}
export default RouteGenerator;
